import clsx from 'clsx';
import { ProjectStatus } from 'generated/graphql';
import styles from './ProjectStatusDropdown.module.scss';

export const STATUS_LABEL_MAP = {
  [ProjectStatus.Closed]: 'Closed',
  [ProjectStatus.Draft]: 'Draft',
  [ProjectStatus.Published]: 'Published',
  [ProjectStatus.Review]: 'In review',
};

export const ALL_STATUS_DROPDOWN_OPTIONS = [
  {
    status: ProjectStatus.Closed,
    label: STATUS_LABEL_MAP[ProjectStatus.Closed],
    additionalInfo:
      'Roles no longer in active use are hidden by default but remain available to company users on demand.',
    icon: (
      <div
        className={clsx(
          styles.iconContainer,
          styles[ProjectStatus.Closed.toLowerCase()],
        )}
      ></div>
    ),
  },
  {
    status: ProjectStatus.Draft,
    label: STATUS_LABEL_MAP[ProjectStatus.Draft],
    additionalInfo:
      'Not visible to company users or candidates. Use when the role is still being set up or should be temporarily hidden.',
    icon: (
      <div
        className={clsx(
          styles.iconContainer,
          styles[ProjectStatus.Draft.toLowerCase()],
        )}
      ></div>
    ),
  },
  {
    status: ProjectStatus.Published,
    label: STATUS_LABEL_MAP[ProjectStatus.Published],
    additionalInfo:
      'Active and visible to company users. Candidates can be added once published.',
    icon: (
      <div
        className={clsx(
          styles.iconContainer,
          styles[ProjectStatus.Published.toLowerCase()],
        )}
      ></div>
    ),
  },
  {
    status: ProjectStatus.Review,
    label: STATUS_LABEL_MAP[ProjectStatus.Review],
    additionalInfo:
      'Visible and accessible to company users but with limited usage.',
    icon: (
      <div
        className={clsx(
          styles.iconContainer,
          styles[ProjectStatus.Review.toLowerCase()],
        )}
      ></div>
    ),
  },
];
